import styled from 'styled-components'

// borderRadius={'12px'} border='1px solid var(--gray200)'

export const Container = styled.table`
border-radius: 12px;
border: 1px solid var(--gray200);
padding: 1rem 0;
margin-top: 1rem;
border-spacing: 0 .25rem;
font-family: 'Roboto','sans-serif';
thead{
    tr{
        color: var(--a2);
        font-weight: 600;
        font-size: 1rem;
    }
    th:first-child{
        padding-left: 4rem;
        text-align: start;
    }
}

tbody{

    tr{
        height:4.125rem;
    }

    tr:nth-child(odd) {
        background-color: #EDF2F7;
    }
    
    tr,th{
        border-collapse: collapse;
        padding: .5rem;
        font-weight: 400;
    }
}
`
